import { ThemeRangeConfig } from "../../store/types"
import { ColumnsType } from "antd/lib/table"

export type ThemeConfigRow = ThemeRangeConfig & {
  dateRange: string;
};

export const themeConfigColumns: ColumnsType<ThemeConfigRow> = [
  {
    title: "Date range",
    dataIndex: "dateRange",
    key: "dateRange",
  },
  {
    title: "Overlay",
    dataIndex: "overlayProps",
    key: "overlayImage",
    render: overlayProps => overlayProps?.src ? <img src={overlayProps.src} alt="" style={{ width: 48, height: 48 }} /> : "-",
  },
  {
    title: "Duration",
    dataIndex: "overlayProps",
    key: "overlayDuration",
    render: overlayProps => overlayProps?.duration ?? "-",
  },
  {
    title: "Item count",
    dataIndex: "overlayProps",
    key: "overlayItemCount",
    render: overlayProps => overlayProps?.itemCount ?? "-",
  },
  {
    title: "Earn banner",
    dataIndex: "earnBanner",
    key: "earnBanner",
    render: src => (src ? <img src={src} alt="" style={{ width: 48, height: 48 }} /> : "-"),
  },
  {
    title: "Marketplace banner",
    dataIndex: "marketplaceBanner",
    key: "marketplaceBanner",
    render: src => (src ? <img src={src} alt="" style={{ width: 48, height: 48 }} /> : "-"),
  },
  {
    title: "Loading icon",
    dataIndex: "loadingIcon",
    key: "loadingIcon",
    render: src => (src ? <img src={src} alt="" style={{ width: 48, height: 48 }} /> : "-"),
  },
]
